<div mat-dialog-title>Comentario</div>
<div mat-dialog-content>
    <div class="d-flex flex-column">
        <div class="comment-box mb-3" [innerHTML]="data.comment"></div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-flat-button (click)="ok()" class="m-r-5 btn-msg">Cerrar</button>
</div>